import { Tag } from '@sweep-io/sweep-design';

export const ListItemAddedTag = ({
  label = 'Added to Canvas',
  color,
}: {
  label?: string;
  color?: string;
}) => <Tag size="small" label={label} color={color} startIconName="CheckCircle" />;
